import { h } from 'preact';

import { isCopilotEnabled } from './gate.js';
import { WorldProvider } from './hooks.jsx';
import CopilotObjects from './objects.jsx';
import CopilotPanel from './CopilotPanel.jsx';

export default function Copilot(_props) {
  if (!isCopilotEnabled()) {
    return null;
  }

  return (
    <WorldProvider>
      <CopilotObjects />
      <CopilotPanel />
    </WorldProvider>
  );
}
